/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_2_Term_Website_DescInputs */

const en_terms_section_2_term_website_desc = /** @type {(inputs: Terms_Section_2_Term_Website_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lindevo.com, together with every page and subdomain under it.`)
};

const lv_terms_section_2_term_website_desc = /** @type {(inputs: Terms_Section_2_Term_Website_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lindevo.com kopā ar visām tās lapām un apakšdomēniem.`)
};

/**
* | output |
* | --- |
* | "lindevo.com, together with every page and subdomain under it." |
*
* @param {Terms_Section_2_Term_Website_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_2_term_website_desc = /** @type {((inputs?: Terms_Section_2_Term_Website_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_2_Term_Website_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_2_term_website_desc(inputs)
	return en_terms_section_2_term_website_desc(inputs)
});